export default {"src":"/_next/static/media/Wim-Van-Cappellen4.d2fff386.JPG","height":1040,"width":1560};